import { z } from 'zod';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';

export const HiringCopilotDropdowns = z
  .object({
    department: z.array(z.string()),
    job_title: z.array(z.string()),
    location: z.array(z.string()),
    start_date: z.array(z.string()),
    end_date: z.array(z.string()),
  })
  .describe('HiringCopilotDropdowns');

export type HiringCopilotDropdowns = z.infer<typeof HiringCopilotDropdowns>;

export const HiringCopilotExtras = z
  .object({
    your_list_subject_ids: z.array(z.string()),
    job_title_group_current: z.string().nullish(),
    produceExplanations: z.boolean().nullish(),
    isExperimentalRun: z.boolean().optional(),
  })
  .describe('HiringCopilotExtras');

export type HiringCopilotExtras = z.infer<typeof HiringCopilotExtras>;

export const HiringCopilotInputs = z
  .object({
    dropdowns: HiringCopilotDropdowns,
    extras: HiringCopilotExtras,
  })
  .describe('HiringCopilotInputs');

export type HiringCopilotInputs = z.infer<typeof HiringCopilotInputs>;

export const HiringCopilotRequest = createCustomVizRequestSchema(
  'hiringCopilot',
  HiringCopilotInputs,
);

export type HiringCopilotRequest = z.infer<typeof HiringCopilotRequest>;

export const JobTitleOrJobGroupType = z.union([
  z.literal('jobTitles'),
  z.literal('jobTitleGroups'),
]);

export type JobTitleOrJobGroupType = z.infer<typeof JobTitleOrJobGroupType>;
